<template>
  <div id="app">
    <!-- <HelloWorld /> -->
    <Index></Index>
  </div>
</template>

<script>
import HelloWorld from './components/HelloWorld.vue'
import Index from './components/index.vue';

export default {
  name: 'app',
  components: {
    HelloWorld,
    Index
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  margin: 0 auto;
  width: 100%;
  min-height: 100vh;
}

body {
  margin: 0;
}
</style>
